//exports.rootUrl = 'http://web02.connectsb.nl:3107'


// exports.rootUrl = 'http://64.225.66.145:4000'
exports.rootUrl = process.env.REACT_APP_BACKEND_URL || 'https://backend.liveresearch.com'
// exports.rootUrl = 'https://beta-backend.liveresearch.com'

//exports.rootUrl = 'https://beta-backend.liveresearch.com'
